// extracted by mini-css-extract-plugin
export default {"tabDashboardUsage":"TabSystemUsage_tabDashboardUsage__eNbxP","rangeSelect":"TabSystemUsage_rangeSelect__VREcd","card":"TabSystemUsage_card__L8pd3"};